import React, { useState, useEffect, useRef } from "react";
import { Pie } from "react-chartjs-2";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Stack,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../../mensajes2";
import { GestionarMarca } from "./modalMarca";
import { GestionarModelo } from "./modalModelo";
import {
  formatMoneda,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
  round,
} from "../../../util/varios";
import { GestionarFabricantes } from "./modalFabricante";
import CatalogoProductos from "../../../catalogos/catalogoProductos";
import { ActualizarTipopro } from "../modalActualizarTipopro";
import { Dimmer } from "../../spinner";
import { Input, Radio, SearchInput, Select } from "../../../ui/inputs/Input";
import {
  DangerButton,
  InfoButton,
  PrimaryButton,
  SuccessButton,
  WarningButton,
} from "../../../ui/buttons/Button";

const TablaProdTerminadoe = (props) => {
  const op = require("../../../../src/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const organizacion = JSON.parse(localStorage.getItem("riforganizacion"));
  //const accbtnproducto = "1111";
  const accbtnproducto = JSON.parse(localStorage.getItem('accproducto')) === null ? "0000" : JSON.parse(localStorage.getItem('accproducto'));
  const [tabIndex, setTabIndex] = useState({ tab1: "tab", tab2: "" });
  const [activeTab, setACtiveTab] = useState({
    tab1: "nav-link active text-light bg-blue-100 rounded",
    tab2: "nav-link text-light bg-blue-200 rounded",
  });
  const [tabPanel, setTabPanel] = useState({
    tab1: "tab-pane fade show active",
    tab2: "tab-pane fade",
  });
  const [grafica, setGrafica] = useState([]);

  const [tabvalid, setTabValid] = useState({ tab1: "true", tab2: "false" });
  const [alerta, setAlerta] = useState({
    max: 0,
    ofe: 0,
    may: 0,
    min: 0,
    maxalt: 0,
    ofealt: 0,
    mayalt: 0,
    minalt: 0,
  });

  const btnIncluir = useRef();
  const btnEditar = useRef();
  const btnEliminar = useRef();
  const btnConsultar = useRef();
  const btnAceptar = useRef();
  const btnCancelar = useRef();
  const txtIdproducto = useRef();
  const txtIdproductoHidden = useRef();
  const txtNombre = useRef();
  const txtNombreCorto = useRef();
  const cmbMarca = useRef();
  const cmbModelo = useRef();
  const cmbTipoProd = useRef();
  const cmbFabricante = useRef();
  const txtReferencia = useRef();
  const txtDiasGar = useRef();
  const cmbUnidMedida = useRef();
  const txtCostoCalcuSinImp = useRef();
  const txtUltimoCostoSinImp = useRef();
  const txtCostoPromeSinImp = useRef();
  const cmbMetodoCosto = useRef();
  const txtCostoProveConImp = useRef();
  const txtCostoCalcuConImp = useRef();
  const txtUltimoCostoConImp = useRef();
  const txtCostoPromeConImp = useRef();
  const txtIvaCompra = useRef();
  const txtPrecioMaxiSinImp = useRef();
  const txtPrecioOfeSinImp = useRef();
  const txtPrecioMayorSinImp = useRef();
  const txtPrecioMiniSinImp = useRef();
  const txtUtilidadMaxi = useRef();
  const txtUtilidadOfe = useRef();
  const txtUtilidadMayor = useRef();
  const txtUtilidadMini = useRef();
  const txtPrecioMaxiConImp = useRef();
  const txtPrecioOfeConImp = useRef();
  const txtPrecioMayorConImp = useRef();
  const txtPrecioMiniConImp = useRef();
  const radioSi = useRef();
  const radioNo = useRef();
  const chkServicio = useRef();
  const txtExento = useRef();
  const txtCodigoVacio = useRef();
  const txtStockMini = useRef();
  const cmbUniVenta = useRef();
  const cmbUniCompra = useRef();
  const cmbUniPrincipal = useRef();
  const cmbUniAlterna = useRef();
  const cmbAlmacen = useRef();
  const txtFactor = useRef();
  const cmbUniFactor = useRef();
  const txtCostoCalcuSinImpAlter = useRef();
  const txtUltimoCostoSinImpAlter = useRef();
  const txtCostoPromeSinImpAlter = useRef();

  const txtPrecioMaxiSinImpAlter = useRef();
  const txtPrecioOfeSinImpAlter = useRef();
  const txtPrecioMayorSinImpAlter = useRef();
  const txtPrecioMiniSinImpAlter = useRef();
  const txtUtilidadMaxiAlter = useRef();
  const txtUtilidadOfeAlter = useRef();
  const txtUtilidadMayorAlter = useRef();
  const txtUtilidadMiniAlter = useRef();
  const txtPrecioMaxiConImpAlter = useRef();
  const txtPrecioOfeConImpAlter = useRef();
  const txtPrecioMayorConImpAlter = useRef();
  const txtPrecioMiniConImpAlter = useRef();

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [habilitadoBot, setHabilitadoBot] = useState(true);
  const [cantidadProd, setCantidadProd] = useState(0);
  const [stockMinimo, setStockMinimo] = useState(0);
  const [nomProducto, setNomProducto] = useState();
  const [habilitarCat, setHabilitarCat] = useState(true);
  const [habilitado, setHabilitado] = useState(false);
  const [body, setBody] = useState(false);
  const [habilitadoAlter, setHabilitadoAlter] = useState(false);
  const [visibleA, setVisibleA] = useState("visible");
  const [costoSelect, setCostoSelect] = useState("1");
  const [precioSelect, setPrecioSelect] = useState("1");
  const [tituloHeader, setTituloHeader] = useState(
    "Gestionar Producto Terminado.",
  );
  const [flujo, setFlujo] = useState([
    "0",
    "10",
    "20",
    "30",
    "40",
    "50",
    "60",
    "70",
    "80",
    "90",
    "100",
  ]);

  const [mostrarMarca, setMostrarMarca] = useState(false);
  const [mostrarModelo, setMostrarModelo] = useState(false);
  const [mostrarTipoP, setMostrarTipoP] = useState(false);
  const [mostrarFabricante, setMostrarFabricante] = useState(false);
  const [mostrarclassvacio, setMostrarclassvacio] = useState(false);
  const [mostrarMedida, setMostrarMedida] = useState(false);
  const [catalogoProducto, setCatalogoProducto] = useState(false);
  const [operacion, setOperacion] = useState(1);
  const [valvacio, setValvacio] = useState(0);
  const [unidadM, setUnidadM] = useState([]);
  const [classvacios] = useState([]);
  const [tipoP, setTipoP] = useState([]);
  const [fabri, setFabri] = useState([]);
  const [marca, setMarca] = useState([]);
  const [modelo, setModelo] = useState([]);
  const [unidadV, setUnidadV] = useState([]);
  const [unidadC, setUnidadC] = useState([]);
  const [factor, setFactor] = useState([]);
  const [moneda] = useState({
    idmoneda: "1",
    descripcion: "BOLIVARES",
    simbolo: "Bs",
    predeterminada: true,
    subpredeterminada: false,
    valormoneda: 1.0,
  });
  const [monedaSub] = useState({
    idmoneda: "4",
    descripcion: "DOLAR",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 1.0,
  });
  const [monedaCambio, setMonedaCambio] = useState({
    idmoneda: "4",
    descripcion: "DOLAR",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 1.0,
  });
  const [imagen, setImagen] = useState({
    imagen: "subir.png",
    imagenactual: "subir.png",
  });
  const [pathImage, setPathImage] = useState({
    imagen: `${op.conexion}/imagen?img=subir.png`,
  });
  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  window.addEventListener("resize", () => {
    setWindowWidth(window.innerWidth);
  });

  const seleccionarTipoProd = () => {
    let campos = "*";
    let nomtab = "tipoproducto";
    let orden = "descripcion";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setTipoP(response.data);
          cmbTipoProd.current.selectedIndex = -1;
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const seleccionarFabricante = () => {
    let campos = "*";
    let nomtab = "fabricante";
    let orden = "descripcion";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setFabri(response.data);
          cmbFabricante.current.selectedIndex = -1;
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const seleccionarUnidadMedida = (ope) => {
    let campos = "*";
    let nomtab = "unidadmedida";
    let orden = "idunidadmedida";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setUnidadM(response.data);
          if (ope === 1) {
            cmbUniPrincipal.current.selectedIndex = 0;
            cmbUnidMedida.current.selectedIndex = 0;
          } else {
            cmbUniPrincipal.current.selectedIndex = -1;
            cmbUnidMedida.current.selectedIndex = -1;
          }
          cmbUniAlterna.current.selectedIndex = -1;
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const agregarUnidad = () => {
    seleccionarUnidadMedida(1);
  };

  const seleccionarMarca = () => {
    let campos = "*";
    let nomtab = "marca";
    let orden = "descripcion";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMarca(response.data);
          cmbMarca.current.selectedIndex = 0;
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarModelo = () => {
    let campos = "*";
    let nomtab = "modelo";
    let orden = "descripcion";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setModelo(response.data);
          cmbModelo.current.selectedIndex = 0;
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const abrirModal = (tipo) => (e) => {
    e.preventDefault();
    if (tipo === "marca") {
      setMostrarMarca(true);
    } else if (tipo === "modelo") {
      setMostrarModelo(true);
    } else if (tipo === "tipop") {
      setMostrarTipoP(true);
    } else if (tipo === "medida") {
      setMostrarMedida(true);
    } else if (tipo === "fabricante") {
      setMostrarFabricante(true);
    } else if (tipo === "classvacios") {
      setMostrarclassvacio(true);
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const handleUpload = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const name = e.target;

      if (file.type.includes("image")) {
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = function load() {
          setPathImage({ ...pathImage, imagen: reader.result });
        };
      }

      // Actualizar el estado de la imagen
      setImagen({
        ...imagen,
        [e.target.name]: file,
        imagenactual: imagen.imagenactual, // Mantener la imagen actual
      });
    }
  };

  const blanquear = () => {
    setFlujo([
      "0",
      "10",
      "20",
      "30",
      "40",
      "50",
      "60",
      "70",
      "80",
      "90",
      "100",
    ]);

    setTituloHeader("Gestionar Producto Terminado.");
    setNomProducto();
    setCantidadProd(0);
    setStockMinimo(0);
    setActivate(false);
    setBody();
    setHabilitado(false);
    setHabilitadoBot(true);
    setUnidadM([]);
    setTipoP([]);
    setFabri([]);
    setMarca([]);
    setModelo([]);
    setAlerta({
      max: 0,
      ofe: 0,
      may: 0,
      min: 0,
      maxalt: 0,
      ofealt: 0,
      mayalt: 0,
      minalt: 0,
    });
    setCostoSelect("1");
    setPrecioSelect("1");
    setMonedaCambio({
      idmoneda: "4",
      descripcion: "DOLAR",
      simbolo: "$",
      predeterminada: false,
      subpredeterminada: true,
      valormoneda: 1.0,
    });

    setImagen({ imagen: "subir.png", imagenactual: "subir.png" });
    setPathImage({ imagen: `${op.conexion}/imagen?img=subir.png` });
    txtIdproducto.current.setAttribute("disabled", true);
    setHabilitarCat(true);
    setVisibleBtn("visible");
    //btnBuscar.current.setAttribute("disabled", true);
    txtIdproducto.current.value = "";

    txtNombre.current.value = "";
    txtNombreCorto.current.value = "";
    txtReferencia.current.value = "";
    txtDiasGar.current.value = "";

    chkServicio.current.checked = false;
    txtExento.current.checked = false;
    cmbAlmacen.current.value = "true";
    txtStockMini.current.value = "0,00";
    setVisibleA("visible");

    cmbMarca.current.selectedIndex = -1;
    cmbModelo.current.selectedIndex = -1;
  };

  const blanquearAlter = () => {
    setValvacio(0);
    setAlerta({
      ...alerta,
      maxalt: 0,
      ofealt: 0,
      mayalt: 0,
      minalt: 0,
    });
    setHabilitadoAlter(false);

    txtFactor.current.value = "";
    setFactor([]);
    setUnidadC([]);
    setUnidadV([]);
    cmbUniPrincipal.current.selectedIndex = -1;
    cmbUniAlterna.current.selectedIndex = -1;
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", "."),
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth,
        );
      }

      if (event.target.id === "costoProveSinImpu") {
        calcularImpuestosCostos();
        if (event.which === 13) {
          txtCostoCalcuSinImp.current.focus();
        }
      } else if (event.target.id === "costoCalcuSinImpu") {
        calcularImpuestosCostos();
        if (event.which === 13) {
          txtUltimoCostoSinImp.current.focus();
        }
      } else if (event.target.id === "costoUltiSinImpu") {
        calcularImpuestosCostos();
        if (event.which === 13) {
          txtCostoPromeSinImp.current.focus();
        }
      } else if (event.target.id === "costoPromeSinImpu") {
        calcularImpuestosCostos();
        if (event.which === 13) {
          txtPrecioMaxiSinImp.current.focus();
        }
      } else if (event.target.id === "preciomaximo") {
        calcularUtilidadxValor(1);
        if (event.which === 13) {
          txtPrecioOfeSinImp.current.focus();
        }
      } else if (event.target.id === "preciooferta") {
        calcularUtilidadxValor(2);
        if (event.which === 13) {
          txtPrecioMayorSinImp.current.focus();
        }
      } else if (event.target.id === "preciomayor") {
        calcularUtilidadxValor(3);
        if (event.which === 13) {
          txtPrecioMiniSinImp.current.focus();
        }
      } else if (event.target.id === "preciominimo") {
        calcularUtilidadxValor(4);
      } else if (event.target.id === "utilidadMaxi") {
        calcularUtilidadxPorce(1);
      } else if (event.target.id === "utilidadOfe") {
        calcularUtilidadxPorce(2);
      } else if (event.target.id === "utilidadMayor") {
        calcularUtilidadxPorce(3);
      } else if (event.target.id === "utilidadMini") {
        calcularUtilidadxPorce(4);
      } else if (event.target.id === "costoProveSinImpuAlter") {
        calcularImpuestosCostosAlter();
        if (event.which === 13) {
          txtCostoCalcuSinImpAlter.current.focus();
        }
      } else if (event.target.id === "costoCalcuSinImpuAlter") {
        calcularImpuestosCostosAlter();
        if (event.which === 13) {
          txtUltimoCostoSinImpAlter.current.focus();
        }
      } else if (event.target.id === "costoUltiSinImpuAlter") {
        calcularImpuestosCostosAlter();
        if (event.which === 13) {
          txtCostoPromeSinImpAlter.current.focus();
        }
      } else if (event.target.id === "costoPromeSinImpuAlter") {
        calcularImpuestosCostosAlter();
        if (event.which === 13) {
          txtUtilidadMaxiAlter.current.focus();
        }
      } else if (event.target.id === "preciomaximoalter") {
        calcularUtilidadxValorAlter(1);
      } else if (event.target.id === "precioofertaalter") {
        calcularUtilidadxValorAlter(2);
      } else if (event.target.id === "preciomayoralter") {
        calcularUtilidadxValorAlter(3);
      } else if (event.target.id === "preciominialter") {
        calcularUtilidadxValorAlter(4);
      } else if (event.target.id === "utilidadMaxiAlter") {
        calcularUtilidadAlter(1);
      } else if (event.target.id === "utilidadOfeAlter") {
        calcularUtilidadAlter(2);
      } else if (event.target.id === "utilidadMayorAlter") {
        calcularUtilidadAlter(3);
      } else if (event.target.id === "utilidadMiniAlter") {
        calcularUtilidadAlter(4);
      } else if (event.target.id === "ivaCompra") {
        calcularImpuestosCostos();
        if (cmbUniFactor.current.selectedIndex >= 0) {
          calcularFactorConversion();
          calcularImpuestosCostosAlter();
        }
        /* if (event.which === 13) {
          txtIvaVenta.current.focus();
        } */
      } else if (event.target.id === "ivaVenta") {
        calcularUtilidadxValor(5);
        if (cmbUniFactor.current.selectedIndex >= 0) {
          calcularFactorConversion();
          calcularImpuestosCostosAlter();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      if (event.target.id === "inputCodigo") {
        txtNombre.current.focus();
      } else if (event.target.id === "inputNombre") {
        txtReferencia.current.focus();
      } else if (event.target.id === "inputRefe") {
        txtNombreCorto.current.focus();
      } else if (event.target.id === "inputNombreCorto") {
        cmbTipoProd.current.focus();
      } else if (event.target.id === "inputDiasGar") {
        cmbMarca.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      return false;
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const calcularImpuestosCostos = () => {
    calcularPrecioSinImpuestos();
  };

  const calcularPrecioSinImpuestos = () => {
    calcularUtilidadxValor(5);
  };

  const calcularPrecioSinImpuestosAlter = () => {
    calcularUtilidadxValorAlter(5);
    calcularImpuestosVentasAlter();
  };

  const calcularImpuestosVentas = () => {
    let costo = 0.0;
    let uti = 0.0;
    let monto = 0.0;
    let valIva = 0.0;
    if (txtPrecioMaxiSinImp.current.value.trim() !== "") {
      let costoMaxi = costo;
      if (costoMaxi <= 0.0) {
        costoMaxi = parseFloat(
          txtPrecioMaxiSinImp.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        );

        monto = (1 + valIva) * costoMaxi;
      } else {
        uti =
          (parseFloat(
            txtUtilidadMaxi.current.value.replace(/\./g, "").replace(",", "."),
          ) *
            costoMaxi) /
          100;
        monto = (1 + valIva) * costoMaxi; //+ uti;
      }

      txtPrecioMaxiConImp.current.value = formatMoneda(
        monto.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2,
      );
    }
    if (txtPrecioOfeSinImp.current.value.trim() !== "") {
      let costoOfe = costo;
      if (costoOfe <= 0.0) {
        costoOfe = parseFloat(
          txtPrecioOfeSinImp.current.value.replace(/\./g, "").replace(",", "."),
        );

        monto = (1 + valIva) * costoOfe;
      } else {
        uti =
          (parseFloat(
            txtUtilidadOfe.current.value.replace(/\./g, "").replace(",", "."),
          ) *
            costoOfe) /
          100;
        monto = (1 + valIva) * costoOfe; // + uti;
      }

      txtPrecioOfeConImp.current.value = formatMoneda(
        monto.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2,
      );
    }
    if (txtPrecioMayorSinImp.current.value.trim() !== "") {
      let costoMayor = costo;
      if (costoMayor <= 0.0) {
        costoMayor = parseFloat(
          txtPrecioMayorSinImp.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        );

        monto = (1 + valIva) * costoMayor;
      } else {
        uti =
          (parseFloat(
            txtUtilidadMayor.current.value.replace(/\./g, "").replace(",", "."),
          ) *
            costoMayor) /
          100;
        monto = (1 + valIva) * costoMayor; //+ uti;
      }

      txtPrecioMayorConImp.current.value = formatMoneda(
        monto.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2,
      );
    }
    if (txtPrecioMiniSinImp.current.value.trim() !== "") {
      let costoMini = costo;
      if (costoMini <= 0.0) {
        costoMini = parseFloat(
          txtPrecioMiniSinImp.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        );

        monto = (1 + valIva) * costoMini;
      } else {
        uti =
          (parseFloat(
            txtUtilidadMini.current.value.replace(/\./g, "").replace(",", "."),
          ) *
            costoMini) /
          100;
        monto = (1 + valIva) * costoMini; //+ uti;
      }

      txtPrecioMiniConImp.current.value = formatMoneda(
        monto.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2,
      );
    }

    if (radioSi.current.checked) {
      calcularPrecioSinImpuestosAlter();
    }
  };

  const calcularUtilidadxValor = (desde) => {
    let mon = 0.0;
    let mon2 = 0.0;
    let utiMax = 0.0,
      utiOfe = 0.0,
      utiMay = 0.0,
      utiMin = 0.0;

    switch (desde) {
      case 1:
        mon2 = parseFloat(
          txtPrecioMaxiSinImp.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        );

        if (mon2 > 0.0) {
          if (mon > 0.0) {
            utiMax = (mon2 - mon) / mon;
            utiMax = utiMax * 100;
          } else {
            utiMax = 100.0;
          }
        }

        if (mon > mon2) {
          txtPrecioMaxiSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioMaxiSinImp.current.style.color = "#000000";
        }

        if (txtPrecioMaxiSinImp.current.value.trim() !== "") {
          txtUtilidadMaxi.current.value = formatMoneda(
            utiMax.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
        }
        break;
      case 2:
        mon2 = parseFloat(
          txtPrecioOfeSinImp.current.value.replace(/\./g, "").replace(",", "."),
        );

        if (mon2 > 0.0) {
          if (mon > 0.0) {
            utiOfe = (mon2 - mon) / mon;
            utiOfe = utiOfe * 100;
          } else {
            utiOfe = 100.0;
          }
        }

        if (mon > mon2) {
          txtPrecioOfeSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioOfeSinImp.current.style.color = "#000000";
        }

        if (txtPrecioOfeSinImp.current.value.trim() !== "") {
          txtUtilidadOfe.current.value = formatMoneda(
            utiOfe.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
        }
        break;
      case 3:
        mon2 = parseFloat(
          txtPrecioMayorSinImp.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        );

        if (mon2 > 0.0) {
          if (mon > 0.0) {
            utiMay = (mon2 - mon) / mon;
            utiMay = utiMay * 100;
          } else {
            utiMay = 100.0;
          }
        }

        if (mon > mon2) {
          txtPrecioMayorSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioMayorSinImp.current.style.color = "#000000";
        }

        if (txtPrecioMayorSinImp.current.value.trim() !== "") {
          txtUtilidadMayor.current.value = formatMoneda(
            utiMay.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
        }
        break;
      case 4:
        mon2 = parseFloat(
          txtPrecioMiniSinImp.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        );

        if (mon2 > 0.0) {
          if (mon > 0.0) {
            utiMin = (mon2 - mon) / mon;
            utiMin = utiMin * 100;
          } else {
            utiMin = 100.0;
          }
        }

        if (mon > mon2) {
          txtPrecioMiniSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioMiniSinImp.current.style.color = "#000000";
        }

        if (txtPrecioMiniSinImp.current.value.trim() !== "") {
          txtUtilidadMini.current.value = formatMoneda(
            utiMin.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
        }
        break;
      case 5:
        mon2 = parseFloat(
          txtPrecioMaxiSinImp.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        );

        if (mon > 0.0) {
          utiMax = (mon2 - mon) / mon;
          utiMax = utiMax * 100;
        }

        if (mon > mon2) {
          txtPrecioMaxiSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioMaxiSinImp.current.style.color = "#000000";
        }

        if (txtPrecioMaxiSinImp.current.value.trim() !== "") {
          txtUtilidadMaxi.current.value = formatMoneda(
            utiMax.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
        }

        mon2 = parseFloat(
          txtPrecioOfeSinImp.current.value.replace(/\./g, "").replace(",", "."),
        );

        if (mon > 0.0) {
          utiOfe = (mon2 - mon) / mon;
          utiOfe = utiOfe * 100;
        }

        if (mon > mon2) {
          txtPrecioOfeSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioOfeSinImp.current.style.color = "#000000";
        }

        if (txtPrecioOfeSinImp.current.value.trim() !== "") {
          txtUtilidadOfe.current.value = formatMoneda(
            utiOfe.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
        }

        mon2 = parseFloat(
          txtPrecioMayorSinImp.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        );

        if (mon > 0.0) {
          utiMay = (mon2 - mon) / mon;
          utiMay = utiMay * 100;
        }

        if (mon > mon2) {
          txtPrecioMayorSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioMayorSinImp.current.style.color = "#000000";
        }

        if (txtPrecioMayorSinImp.current.value.trim() !== "") {
          txtUtilidadMayor.current.value = formatMoneda(
            utiMay.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
        }

        mon2 = parseFloat(
          txtPrecioMiniSinImp.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        );

        if (mon > 0.0) {
          utiMin = (mon2 - mon) / mon;
          utiMin = utiMin * 100;
        }

        if (mon > mon2) {
          txtPrecioMiniSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioMiniSinImp.current.style.color = "#000000";
        }

        if (txtPrecioMiniSinImp.current.value.trim() !== "") {
          txtUtilidadMini.current.value = formatMoneda(
            utiMin.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
        }

        break;
    }
    calcularImpuestosVentas();
  };

  const calcularUtilidadxPorce = (desde) => {
    let monto = 0.0,
      valUti = 0.0;
    let mon = 0.0;

    if (cmbMetodoCosto.current.value === "2") {
      mon = parseFloat(
        txtCostoCalcuSinImp.current.value.replace(/\./g, "").replace(",", "."),
      );
    }

    if (cmbMetodoCosto.current.value === "3") {
      mon = parseFloat(
        txtUltimoCostoSinImp.current.value.replace(/\./g, "").replace(",", "."),
      );
    }

    if (cmbMetodoCosto.current.value === "4") {
      mon = parseFloat(
        txtCostoPromeSinImp.current.value.replace(/\./g, "").replace(",", "."),
      );
    }

    switch (desde) {
      case 1:
        valUti =
          parseFloat(
            txtUtilidadMaxi.current.value.replace(/\./g, "").replace(",", "."),
          ) / 100;

        if (mon > 0.0) {
          monto = (1 + valUti) * mon;
          txtPrecioMaxiSinImp.current.value = formatMoneda(
            monto.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
          //txtUtilidadOfe.current.focus();
        } else if (
          parseFloat(
            txtPrecioMaxiSinImp.current.value
              .replace(/\./g, "")
              .replace(",", "."),
          ) <= 0.0
        ) {
          txtUtilidadMaxi.current.value = "0,00";
          txtPrecioMaxiSinImp.current.focus();
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "El Precio Maximo no puede ser 0,00.",
            icono: "informacion",
          });
        } else {
          txtUtilidadMaxi.current.value = "100,00";
          //txtUtilidadOfe.current.focus();
        }

        if (mon > monto) {
          txtPrecioMaxiSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioMaxiSinImp.current.style.color = "#000000";
        }

        break;
      case 2:
        valUti =
          parseFloat(
            txtUtilidadOfe.current.value.replace(/\./g, "").replace(",", "."),
          ) / 100;

        if (mon > 0.0) {
          monto = (1 + valUti) * mon;
          txtPrecioOfeSinImp.current.value = formatMoneda(
            monto.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
        } else if (
          parseFloat(
            txtPrecioOfeSinImp.current.value
              .replace(/\./g, "")
              .replace(",", "."),
          ) <= 0.0
        ) {
          txtUtilidadOfe.current.value = "0,00";
          txtPrecioOfeSinImp.current.focus();
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "El Precio Oferta no puede ser 0,00.",
            icono: "informacion",
          });
        } else {
          txtUtilidadOfe.current.value = "100,00";
        }

        if (mon > monto) {
          txtPrecioOfeSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioOfeSinImp.current.style.color = "#000000";
        }

        break;
      case 3:
        valUti =
          parseFloat(
            txtUtilidadMayor.current.value.replace(/\./g, "").replace(",", "."),
          ) / 100;

        if (mon > 0.0) {
          monto = (1 + valUti) * mon;
          txtPrecioMayorSinImp.current.value = formatMoneda(
            monto.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
        } else if (
          parseFloat(
            txtPrecioMayorSinImp.current.value
              .replace(/\./g, "")
              .replace(",", "."),
          ) <= 0.0
        ) {
          txtUtilidadMayor.current.value = "0,00";
          txtPrecioMayorSinImp.current.focus();
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "El Precio Mayor no puede ser 0,00.",
            icono: "informacion",
          });
        } else {
          txtUtilidadMayor.current.value = "100,00";
        }

        if (mon > monto) {
          txtPrecioMayorSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioMayorSinImp.current.style.color = "#000000";
        }

        break;
      case 4:
        valUti =
          parseFloat(
            txtUtilidadMini.current.value.replace(/\./g, "").replace(",", "."),
          ) / 100;

        if (mon > 0.0) {
          monto = (1 + valUti) * mon;
          txtPrecioMiniSinImp.current.value = formatMoneda(
            monto.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
        } else if (
          parseFloat(
            txtPrecioMiniSinImp.current.value
              .replace(/\./g, "")
              .replace(",", "."),
          ) <= 0.0
        ) {
          txtUtilidadMini.current.value = "0,00";
          txtPrecioMiniSinImp.current.focus();
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "El Precio Minimo no puede ser 0,00.",
            icono: "informacion",
          });
        } else {
          txtUtilidadMini.current.value = "100,00";
        }

        if (mon > monto) {
          txtPrecioMiniSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioMiniSinImp.current.style.color = "#000000";
        }

        break;
      case 5:
        if (mon > 0.0) {
          valUti =
            parseFloat(
              txtUtilidadMaxi.current.value
                .replace(/\./g, "")
                .replace(",", "."),
            ) / 100;

          if (txtPrecioMaxiSinImp.current.value.trim() !== "") {
            monto = (1 + valUti) * mon;
            txtPrecioMaxiSinImp.current.value = formatMoneda(
              monto.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2,
            );
          }
          valUti =
            parseFloat(
              txtUtilidadOfe.current.value.replace(/\./g, "").replace(",", "."),
            ) / 100;
          if (txtPrecioOfeSinImp.current.value.trim() !== "") {
            monto = (1 + valUti) * mon;
            txtPrecioOfeSinImp.current.value = formatMoneda(
              monto.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2,
            );
          }
          valUti =
            parseFloat(
              txtUtilidadMayor.current.value
                .replace(/\./g, "")
                .replace(",", "."),
            ) / 100;
          if (txtPrecioMayorSinImp.current.value.trim() !== "") {
            monto = (1 + valUti) * mon;
            txtPrecioMayorSinImp.current.value = formatMoneda(
              monto.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2,
            );
          }
          valUti =
            parseFloat(
              txtUtilidadMini.current.value
                .replace(/\./g, "")
                .replace(",", "."),
            ) / 100;
          if (txtPrecioMiniSinImp.current.value.trim() !== "") {
            monto = (1 + valUti) * mon;
            txtPrecioMiniSinImp.current.value = formatMoneda(
              monto.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2,
            );
          }
        }

        break;
    }

    calcularImpuestosVentas();
  };

  const calcularFactorConversion = () => {
    let unifactor = cmbUniFactor.current.selectedIndex;
    let costoProv = 0.0,
      costoCal = 0.0,
      costoUlt = 0.0,
      costoProm = 0.0;
    let valor = parseFloat(
      txtFactor.current.value.replace(/\./g, "").replace(",", "."),
    );
    let mon = 0.0;

    if (cmbMetodoCosto.current.value === "1") {
      mon = parseFloat(
        txtCostoProveConImp.current.value.replace(/\./g, "").replace(",", "."),
      );
    }

    if (cmbMetodoCosto.current.value === "2") {
      mon = parseFloat(
        txtCostoCalcuConImp.current.value.replace(/\./g, "").replace(",", "."),
      );
    }

    if (cmbMetodoCosto.current.value === "3") {
      mon = parseFloat(
        txtUltimoCostoConImp.current.value.replace(/\./g, "").replace(",", "."),
      );
    }

    if (cmbMetodoCosto.current.value === "4") {
      mon = parseFloat(
        txtCostoPromeConImp.current.value.replace(/\./g, "").replace(",", "."),
      );
    }

    costoCal = parseFloat(
      txtCostoCalcuSinImp.current.value.replace(/\./g, "").replace(",", "."),
    );
    costoUlt = parseFloat(
      txtUltimoCostoSinImp.current.value.replace(/\./g, "").replace(",", "."),
    );
    costoProm = parseFloat(
      txtCostoPromeSinImp.current.value.replace(/\./g, "").replace(",", "."),
    );

    if (unifactor === 0) {
      precio = mon * valor;
      costoProv = costoProv * valor;
      costoCal = costoCal * valor;
      costoUlt = costoUlt * valor;
      costoProm = costoProm * valor;
    } else {
      precio = mon / valor;
      costoProv = costoProv / valor;
      costoCal = costoCal / valor;
      costoUlt = costoUlt / valor;
      costoProm = costoProm / valor;
    }

    calcularImpuestosCostosAlter();
  };

  const calcularImpuestosCostosAlter = () => {
    calcularPrecioSinImpuestosAlter();
  };

  const calcularImpuestosVentasAlter = () => {
    let costo = 0.0;
    let uti = 0.0;
    let monto = 0.0;
    let valIva = 0.0;

    if (txtPrecioMaxiSinImpAlter.current.value.trim() !== "") {
      let costoMaxi = costo;
      if (costoMaxi <= 0.0) {
        costoMaxi = parseFloat(
          txtPrecioMaxiSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        );

        monto = (1 + valIva) * costoMaxi;
      } else {
        uti =
          (parseFloat(
            txtUtilidadMaxiAlter.current.value
              .replace(/\./g, "")
              .replace(",", "."),
          ) *
            costoMaxi) /
          100;
        monto = (1 + valIva) * costoMaxi + uti;
      }

      txtPrecioMaxiConImpAlter.current.value = formatMoneda(
        monto.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2,
      );
    }
    if (txtPrecioOfeSinImpAlter.current.value.trim() !== "") {
      let costoOfe = costo;
      if (costoOfe <= 0.0) {
        costoOfe = parseFloat(
          txtPrecioOfeSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        );

        monto = (1 + valIva) * costoOfe;
      } else {
        uti =
          (parseFloat(
            txtUtilidadOfeAlter.current.value
              .replace(/\./g, "")
              .replace(",", "."),
          ) *
            costoOfe) /
          100;
        monto = (1 + valIva) * costoOfe + uti;
      }

      txtPrecioOfeConImpAlter.current.value = formatMoneda(
        monto.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2,
      );
    }
    if (txtPrecioMayorSinImpAlter.current.value.trim() !== "") {
      let costoMayor = costo;
      if (costoMayor <= 0.0) {
        costoMayor = parseFloat(
          txtPrecioMayorSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        );

        monto = (1 + valIva) * costoMayor;
      } else {
        uti =
          (parseFloat(
            txtUtilidadMayorAlter.current.value
              .replace(/\./g, "")
              .replace(",", "."),
          ) *
            costoMayor) /
          100;
        monto = (1 + valIva) * costoMayor + uti;
      }

      txtPrecioMayorConImpAlter.current.value = formatMoneda(
        monto.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2,
      );
    }
    if (txtPrecioMiniSinImpAlter.current.value.trim() !== "") {
      let costoMini = costo;
      if (costoMini <= 0.0) {
        costoMini = parseFloat(
          txtPrecioMiniSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        );

        monto = (1 + valIva) * costoMini;
      } else {
        uti =
          (parseFloat(
            txtUtilidadMiniAlter.current.value
              .replace(/\./g, "")
              .replace(",", "."),
          ) *
            costoMini) /
          100;
        monto = (1 + valIva) * costoMini + uti;
      }

      txtPrecioMiniConImpAlter.current.value = formatMoneda(
        monto.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2,
      );
    }
  };

  const calcularUtilidadAlter = (desde) => {
    let monto = 0.0,
      valUti = 0.0;
    let mon = 0.0;

    switch (desde) {
      case 1:
        valUti =
          parseFloat(
            txtUtilidadMaxiAlter.current.value
              .replace(/\./g, "")
              .replace(",", "."),
          ) / 100;

        if (mon > 0.0) {
          monto = (1 + valUti) * mon;
          txtPrecioMaxiSinImpAlter.current.value = formatMoneda(
            monto.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
          //txtUtilidadOfe.current.focus();
        } else if (
          parseFloat(
            txtPrecioMaxiSinImpAlter.current.value
              .replace(/\./g, "")
              .replace(",", "."),
          ) <= 0.0
        ) {
          txtUtilidadMaxiAlter.current.value = "0,00";
          txtPrecioMaxiSinImpAlter.current.focus();
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "El Precio Maximo no puede ser 0,00.",
            icono: "informacion",
          });
        } else {
          txtUtilidadMaxiAlter.current.value = "100,00";
          //txtUtilidadOfe.current.focus();
        }

        if (mon > monto) {
          txtPrecioMaxiSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioMaxiSinImpAlter.current.style.color = "#000000";
        }

        break;
      case 2:
        valUti =
          parseFloat(
            txtUtilidadOfeAlter.current.value
              .replace(/\./g, "")
              .replace(",", "."),
          ) / 100;

        if (mon > 0.0) {
          monto = (1 + valUti) * mon;
          txtPrecioOfeSinImpAlter.current.value = formatMoneda(
            monto.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
          //txtUtilidadMayor.current.focus();
        } else if (
          parseFloat(
            txtPrecioOfeSinImpAlter.current.value
              .replace(/\./g, "")
              .replace(",", "."),
          ) <= 0.0
        ) {
          txtUtilidadOfeAlter.current.value = "0,00";
          txtPrecioOfeSinImpAlter.current.focus();
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "El Precio Oferta no puede ser 0,00.",
            icono: "informacion",
          });
        } else {
          txtUtilidadOfeAlter.current.value = "100,00";
          //txtUtilidadMayor.current.focus();
        }

        if (mon > monto) {
          txtPrecioOfeSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioOfeSinImpAlter.current.style.color = "#000000";
        }

        break;
      case 3:
        valUti =
          parseFloat(
            txtUtilidadMayorAlter.current.value
              .replace(/\./g, "")
              .replace(",", "."),
          ) / 100;

        if (mon > 0.0) {
          monto = (1 + valUti) * mon;
          txtPrecioMayorSinImpAlter.current.value = formatMoneda(
            monto.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
          //txtUtilidadMini.current.focus();
        } else if (
          parseFloat(
            txtPrecioMayorSinImpAlter.current.value
              .replace(/\./g, "")
              .replace(",", "."),
          ) <= 0.0
        ) {
          txtUtilidadMayorAlter.current.value = "0,00";
          txtPrecioMayorSinImpAlter.current.focus();
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "El Precio Mayor no puede ser 0,00.",
            icono: "informacion",
          });
        } else {
          txtUtilidadMayorAlter.current.value = "100,00";
          //txtUtilidadMini.current.focus();
        }

        if (mon > monto) {
          txtPrecioMayorSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioMayorSinImpAlter.current.style.color = "#000000";
        }

        break;
      case 4:
        valUti =
          parseFloat(
            txtUtilidadMiniAlter.current.value
              .replace(/\./g, "")
              .replace(",", "."),
          ) / 100;

        if (mon > 0.0) {
          monto = (1 + valUti) * mon;
          txtPrecioMiniSinImpAlter.current.value = formatMoneda(
            monto.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
          //radioNo.current.focus();
        } else if (
          parseFloat(
            txtPrecioMiniSinImpAlter.current.value
              .replace(/\./g, "")
              .replace(",", "."),
          ) <= 0.0
        ) {
          txtUtilidadMiniAlter.current.value = "0,00";
          txtPrecioMiniSinImpAlter.current.focus();
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "El Precio Minimo no puede ser 0,00.",
            icono: "informacion",
          });
        } else {
          txtUtilidadMiniAlter.current.value = "100,00";
          // radioNo.current.focus();
        }

        if (mon > monto) {
          txtPrecioMiniSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioMiniSinImpAlter.current.style.color = "#000000";
        }

        break;
      case 5:
        if (mon > 0.0) {
          valUti =
            parseFloat(
              txtUtilidadMaxiAlter.current.value
                .replace(/\./g, "")
                .replace(",", "."),
            ) / 100;

          if (txtPrecioMaxiSinImpAlter.current.value.trim() !== "") {
            monto = (1 + valUti) * mon;
            txtPrecioMaxiSinImpAlter.current.value = formatMoneda(
              monto.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2,
            );
          }
          valUti =
            parseFloat(
              txtUtilidadOfeAlter.current.value
                .replace(/\./g, "")
                .replace(",", "."),
            ) / 100;
          if (txtPrecioOfeSinImpAlter.current.value.trim() !== "") {
            monto = (1 + valUti) * mon;
            txtPrecioOfeSinImpAlter.current.value = formatMoneda(
              monto.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2,
            );
          }
          valUti =
            parseFloat(
              txtUtilidadMayorAlter.current.value
                .replace(/\./g, "")
                .replace(",", "."),
            ) / 100;
          if (txtPrecioMayorSinImpAlter.current.value.trim() !== "") {
            monto = (1 + valUti) * mon;
            txtPrecioMayorSinImpAlter.current.value = formatMoneda(
              monto.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2,
            );
          }
          valUti =
            parseFloat(
              txtUtilidadMiniAlter.current.value
                .replace(/\./g, "")
                .replace(",", "."),
            ) / 100;
          if (txtPrecioMiniSinImpAlter.current.value.trim() !== "") {
            monto = (1 + valUti) * mon;
            txtPrecioMiniSinImpAlter.current.value = formatMoneda(
              monto.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2,
            );
          }
        }

        break;
    }

    calcularImpuestosVentasAlter();
  };

  const calcularUtilidadxValorAlter = (desde) => {
    let mon = 0.0;

    if (cmbMetodoCosto.current.value === "4") {
      mon = parseFloat(
        txtCostoPromeSinImpAlter.current.value
          .replace(/\./g, "")
          .replace(",", "."),
      );
    }

    let mon2 = 0.0;
    let mon3 = 0.0;

    switch (desde) {
      case 1:
        mon2 = parseFloat(
          txtPrecioMaxiSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        );

        if (mon2 > 0.0) {
          if (mon > 0.0) {
            mon3 = (mon2 - mon) / mon;
            mon3 = mon3 * 100;
          } else {
            mon3 = 100.0;
          }
        }

        if (mon > mon2) {
          txtPrecioMaxiSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioMaxiSinImpAlter.current.style.color = "#000000";
        }

        if (txtPrecioMaxiSinImpAlter.current.value.trim() !== "") {
          txtUtilidadMaxiAlter.current.value = formatMoneda(
            mon3.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
        }
        break;
      case 2:
        mon2 = parseFloat(
          txtPrecioOfeSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        );

        if (mon2 > 0.0) {
          if (mon > 0.0) {
            mon3 = (mon2 - mon) / mon;
            mon3 = mon3 * 100;
          } else {
            mon3 = 100.0;
          }
        }

        if (mon > mon2) {
          txtPrecioOfeSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioOfeSinImpAlter.current.style.color = "#000000";
        }

        if (txtPrecioOfeSinImpAlter.current.value.trim() !== "") {
          txtUtilidadOfeAlter.current.value = formatMoneda(
            mon3.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
        }
        break;
      case 3:
        mon2 = parseFloat(
          txtPrecioMayorSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        );

        if (mon2 > 0.0) {
          if (mon > 0.0) {
            mon3 = (mon2 - mon) / mon;
            mon3 = mon3 * 100;
          } else {
            mon3 = 100.0;
          }
        }

        if (mon > mon2) {
          txtPrecioMayorSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioMayorSinImpAlter.current.style.color = "#000000";
        }

        if (txtPrecioMayorSinImpAlter.current.value.trim() !== "") {
          txtUtilidadMayorAlter.current.value = formatMoneda(
            mon3.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
        }
        break;
      case 4:
        mon2 = parseFloat(
          txtPrecioMiniSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        );

        if (mon2 > 0.0) {
          if (mon > 0.0) {
            mon3 = (mon2 - mon) / mon;
            mon3 = mon3 * 100;
          } else {
            mon3 = 100.0;
          }
        }

        if (mon > mon2) {
          txtPrecioMiniSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioMiniSinImpAlter.current.style.color = "#000000";
        }

        if (txtPrecioMiniSinImpAlter.current.value.trim() !== "") {
          txtUtilidadMiniAlter.current.value = formatMoneda(
            mon3.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
        }
        break;
      case 5:
        mon2 = parseFloat(
          txtPrecioMaxiSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        );

        if (mon > 0.0) {
          mon3 = (mon2 - mon) / mon;
          mon3 = mon3 * 100;
        }

        if (mon > mon2) {
          txtPrecioMaxiSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioMaxiSinImpAlter.current.style.color = "#000000";
        }

        if (txtPrecioMaxiSinImpAlter.current.value.trim() !== "") {
          txtUtilidadMaxiAlter.current.value = formatMoneda(
            mon3.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
        }

        mon2 = parseFloat(
          txtPrecioOfeSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        );

        if (mon > 0.0) {
          mon3 = (mon2 - mon) / mon;
          mon3 = mon3 * 100;
        }

        if (mon > mon2) {
          txtPrecioOfeSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioOfeSinImpAlter.current.style.color = "#000000";
        }

        if (txtPrecioOfeSinImpAlter.current.value.trim() !== "") {
          txtUtilidadOfeAlter.current.value = formatMoneda(
            mon3.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
        }

        mon2 = parseFloat(
          txtPrecioMayorSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        );

        if (mon > 0.0) {
          mon3 = (mon2 - mon) / mon;
          mon3 = mon3 * 100;
        }

        if (mon > mon2) {
          txtPrecioMayorSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioMayorSinImpAlter.current.style.color = "#000000";
        }

        if (txtPrecioMayorSinImpAlter.current.value.trim() !== "") {
          txtUtilidadMayorAlter.current.value = formatMoneda(
            mon3.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
        }

        mon2 = parseFloat(
          txtPrecioMiniSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        );

        if (mon > 0.0) {
          mon3 = (mon2 - mon) / mon;
          mon3 = mon3 * 100;
        }

        if (mon > mon2) {
          txtPrecioMiniSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioMiniSinImpAlter.current.style.color = "#000000";
        }

        if (txtPrecioMiniSinImpAlter.current.value.trim() !== "") {
          txtUtilidadMiniAlter.current.value = formatMoneda(
            mon3.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2,
          );
        }

        break;
    }

    calcularImpuestosVentasAlter();
  };

  const unidadAlterna = (event) => {
    if (radioSi.current.checked) {
      setTabIndex({ tab1: "tab", tab2: "tab" });
      setACtiveTab({
        tab1: "nav-link text-light bg-blue-100 rounded",
        tab2: "nav-link active text-light bg-blue-200 rounded",
      });
      setTabValid({ tab1: "false", tab2: "true" });
      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
      setHabilitadoAlter(true);

      txtFactor.current.value = "1,00";
      cmbUniPrincipal.current.value = cmbUnidMedida.current.value;
      cmbUniPrincipal.current.focus();
    } else {
      setTabIndex({ tab1: "tab", tab2: "" });
      setHabilitadoAlter(false);
      blanquearAlter();
    }
  };

  const manesillas = (stock, existencia) => {
    if (existencia === undefined) {
    }

    if (stock === undefined) {
      setCantidadProd(0);
    } else {
      let array = [0];
      let n = parseFloat(stock) * 4;
      let n1 = 0;
      let n2 = 0;
      if (parseFloat(existencia) > parseFloat(n)) {
        n1 = parseFloat(existencia) / 10;
        for (let i = 0; i < 12; i++) {
          n2 = n2 + n1;
          array.push(parseFloat(n2.toFixed(2)));
        }
      } else {
        n1 = n / 10;
        for (let i = 0; i < 10; i++) {
          n2 = n2 + n1;
          array.push(parseFloat(n2.toFixed(2)));
        }
      }

      setFlujo(array);
    }
  };

  const onChange = (e) => {
    if (e.target.name === "codigo") {
      e.target.value = e.target.value.toUpperCase();
    } else if (
      e.target.name === "unidadP" ||
      e.target.name === "unidadA" ||
      e.target.name === "idunidadmedida"
    ) {
      if (cmbUniPrincipal.current.selectedIndex >= 0) {
        var unic = [];
        var univ = [];
        setUnidadC([]);
        setUnidadV([]);
        if (e.target.name === "idunidadmedida") {
          cmbUniPrincipal.current.selectedIndex =
            cmbUnidMedida.current.selectedIndex;
        } else {
          cmbUnidMedida.current.selectedIndex =
            cmbUniPrincipal.current.selectedIndex;
        }

        unic.push({
          idunidadmedida: cmbUniPrincipal.current.value,
          descripcion:
            cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex].text,
        });

        univ.push({
          idunidadmedida: cmbUniPrincipal.current.value,
          descripcion:
            cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex].text,
        });

        if (cmbUniAlterna.current.selectedIndex >= 0) {
          unic.push({
            idunidadmedida: cmbUniAlterna.current.value,
            descripcion:
              cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text,
          });

          univ.push({
            idunidadmedida: cmbUniAlterna.current.value,
            descripcion:
              cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text,
          });

          var uni = [];
          uni.push({
            iduni: "0",
            descripcion:
              cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex]
                .text +
              "X" +
              cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text,
          });
          uni.push({
            iduni: "1",
            descripcion:
              cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text +
              "X" +
              cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex]
                .text,
          });
          setFactor(uni);
          cmbUniFactor.current.selectedIndex = -1;
        }
        setUnidadC(unic);
        setUnidadV(univ);
        cmbUniVenta.current.selectedIndex = -1;
        cmbUniCompra.current.selectedIndex = -1;
      }
    } else if (e.target.name === "almacen") {
      if (e.target.value === "true") {
        setVisibleA("visible");
        txtStockMini.current.value = "0,00";
      } else {
        setVisibleA("hidden");
        txtStockMini.current.value = "0,00";
      }
      /*       if (e.target.checked === true) {
        setVisibleA("visible");
        txtStockMini.current.value = "0,00";
      } else {
        setVisibleA("hidden");
        txtStockMini.current.value = "0,00";
      } */
    } else if (e.target.name === "unifactor") {
      calcularFactorConversion();
      // calcularImpuestosCostosAlter();
      // calcularUtilidadAlter(5);
      // calcularImpuestosVentasAlter();
    } else if (e.target.name === "metodocosto") {
      setCostoSelect(e.target.value);
      calcularPrecioSinImpuestos();
    }
  };

  const onChangeValidar = () => {
    var sigue = true;

    let tasa = 0.0;
    if (monedaCambio.idmoneda === monedaSub.idmoneda) {
      tasa = 1.0;
    } else if (monedaCambio.idmoneda === moneda.idmoneda) {
      tasa = monedaSub.valormoneda;
    } else {
      tasa = round(monedaSub.valormoneda / monedaCambio.valormoneda);
    }

    if (sigue) {
      var prod = [];
      prod.push({
        idproducto: txtIdproducto.current.value,
        descripcion: txtNombre.current.value.toUpperCase(),
        idunidadmedida: cmbUnidMedida.current.value,
        idtipoproducto: cmbTipoProd.current.value,
        exento: txtExento.current.checked,
        almacen: cmbAlmacen.current.value === "true" ? true : false,
        stockminimo: parseFloat(
          txtStockMini.current.value.replace(/\./g, "").replace(",", "."),
        ),
        servicio: chkServicio.current.checked,
        descripcioncorta: txtNombreCorto.current.value.toUpperCase(),
        codigo: txtIdproducto.current.value.toUpperCase(),
        marca: cmbMarca.current.value === "" ? 0 : cmbMarca.current.value,
        modelo: cmbModelo.current.value === "" ? 0 : cmbModelo.current.value,
        referencia: txtReferencia.current.value.toUpperCase(),
        diasgarantia:
          txtDiasGar.current.value === "" ? null : txtDiasGar.current.value,
        idfabricante: cmbFabricante.current.value,
        idunidadalterna: cmbUniAlterna.current.value,
        idunidadingreso: cmbUniCompra.current.value,
        idunidadsalida: cmbUniVenta.current.value,
        valorfactor: txtFactor.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        tipofactor: cmbUniFactor.current.value,
      });

      // Crear FormData en lugar de un objeto JSON
      const formData = new FormData();
      formData.append("operacion", operacion);
      formData.append("producto", JSON.stringify(prod));
      formData.append("codigo", txtIdproducto.current.value.toUpperCase());
      formData.append("imagenactual", imagen.imagenactual);

      // Agregar la imagen si existe y no es la imagen por defecto
      if (
        imagen.imagen &&
        imagen.imagen !== "subir.png" &&
        typeof imagen.imagen !== "string"
      ) {
        formData.append("imagen", imagen.imagen);
      }


      setBody(formData);

      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const tabs = (vl) => (e) => {
    e.preventDefault();

    if (vl === 2 && tabIndex.tab2 !== "") {
      setACtiveTab({
        tab1: "nav-link text-light bg-blue-100 rounded",
        tab2: "nav-link active text-light bg-blue-200 rounded",
      });
      setTabValid({ tab1: "false", tab2: "true" });
      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
    } else {
      setACtiveTab({
        tab1: "nav-link active text-light bg-blue-100 rounded",
        tab2: "nav-link text-light bg-blue-200 rounded",
      });
      setTabValid({ tab1: "true", tab2: "false" });
      setTabPanel({
        tab1: "tab-pane fade show active",
        tab2: "tab-pane fade ",
      });
    }
  };
  const seleccionarRegistrosGrafica = () => {
    let campos = `
      COUNT(*) FILTER (WHERE servicio = true) AS servicio,
      COUNT(*) FILTER (WHERE servicio = false) AS bienes
    `;
    let nomtab = `producto`;
    let orden = `servicio`;

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200 && response.data.length > 0) {
          setGrafica(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {
        setActivate(false);
      });
  };
  const seleccionarRegistro = (id) => {
    let campos = "*";
    let nomtab = "producto";
    let nomid = "idproducto";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            txtIdproducto.current.setAttribute("disabled", true);
            setHabilitarCat(true);


            if (
              response.data.imagen.trim() !== "subir.png" &&
              response.data.imagen.trim() !== null &&
              response.data.imagen.trim() !== ""
            ) {
              setImagen({
                ...imagen,
                imagenactual: response.data.imagen.trim(),
              });
              setPathImage({
                imagen: `${op.conexion}/imagenproducto?img=${response.data.imagen.trim()}`,
              });
            }

            txtIdproductoHidden.current.value = response.data.idproducto;
            chkServicio.current.checked = response.data.servicio;
            txtExento.current.checked = response.data.exento;
            txtIdproducto.current.value = response.data.idproducto.trim();
            txtNombre.current.value = response.data.descripcion.trim();
            txtReferencia.current.value = response.data.referencia;
            txtNombreCorto.current.value = response.data.descripcioncorta
              ? response.data.descripcioncorta.trim()
              : "";
            cmbTipoProd.current.value = response.data.idtipoproducto;
            cmbFabricante.current.value = response.data.idfabricante;

            txtDiasGar.current.value = response.data.diasgarantia;
            cmbMarca.current.value = response.data.marca;
            cmbModelo.current.value = response.data.modelo;

            cmbUnidMedida.current.value = response.data.idunidadmedida;
            cmbAlmacen.current.value = response.data.almacen ? "true" : "false";
            txtStockMini.current.value =
              response.data.stockminimo === null
                ? "0,00"
                : formatMoneda(
                    response.data.stockminimo
                      .toString()
                      .replace(",", "")
                      .replace(".", ","),
                    ",",
                    ".",
                    2,
                  );

            if (response.data.idunidadalterna > 0) {
              radioSi.current.checked = true;
              radioNo.current.checked = false;
              setTabIndex({ tab1: "tab", tab2: "tab" });
              if (operacion === 2) {
                setHabilitadoAlter(true);
              }
              cmbUniPrincipal.current.value = response.data.idunidadmedida;
              cmbUniAlterna.current.value = response.data.idunidadalterna;
              txtFactor.current.value = formatMoneda(
                response.data.valorfactor
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2,
              );
              var uni = [];
              uni.push({
                iduni: "0",
                descripcion:
                  cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex]
                    .text +
                  "X" +
                  cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex]
                    .text,
              });
              uni.push({
                iduni: "1",
                descripcion:
                  cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex]
                    .text +
                  "X" +
                  cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex]
                    .text,
              });
              setFactor(uni);

              cmbUniFactor.current.value = response.data.tipofactor;
              var unic = [];
              var univ = [];
              setUnidadC([]);
              setUnidadV([]);

              unic.push({
                idunidadmedida: cmbUniPrincipal.current.value,
                descripcion:
                  cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex]
                    .text,
              });

              univ.push({
                idunidadmedida: cmbUniPrincipal.current.value,
                descripcion:
                  cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex]
                    .text,
              });

              unic.push({
                idunidadmedida: cmbUniAlterna.current.value,
                descripcion:
                  cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex]
                    .text,
              });
              univ.push({
                idunidadmedida: cmbUniAlterna.current.value,
                descripcion:
                  cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex]
                    .text,
              });
              setUnidadC(unic);
              setUnidadV(univ);
            }

            setStockMinimo(response.data.stockminimo);
            setNomProducto(response.data.nombre);

            if (response.data.almacen) {
              setVisibleA("visible");
            }

            if (operacion === 2) {
              setHabilitado(true);
            } else {
              btnAceptar.current.focus();
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Producto no existe.",
              icono: "informacion",
            });
            txtIdproducto.current.value = "";
            txtIdproducto.current.focus();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarProducto = (event) => {
    event.preventDefault();
    // validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "" && operacion !== 1) {
        seleccionarRegistro(event.target.value);
      }
    }
  };

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/comprasAlmacen/actproducto`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
          blanquear();
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = error;
        } else {
          mensaje = error.response.data.message;
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const onCatalogoProducto = (values) => {
    setCatalogoProducto(false);
    if (values) {
      seleccionarRegistro(values);
    }
  };

  const imprimirAlmacen = () => {
    if (accbtnproducto && accbtnproducto.toString().substring(4, 5) === "1") {
      window.open(
        `${op.reportes}/productos?afiliado=${organizacion}&reporte=ListaProducto`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      if (accbtnproducto && accbtnproducto.toString().substring(1, 2) === "1") {
        setHabilitadoBot(false);
        setVisibleBtn("hidden");
        setTituloHeader("Incluir Producto Terminado.");
        setOperacion(op);
        setHabilitado(true);
        seleccionarUnidadMedida(op);
        seleccionarTipoProd();
        seleccionarFabricante();
        seleccionarMarca();
        seleccionarModelo();
        // seleccionarMoneda();
        txtIdproducto.current.value = "";
        txtIdproductoHidden.current.value = "0";
        //   txtIdproducto.current.removeAttribute("disabled");
        setHabilitarCat(true);
        txtDiasGar.current.value = "0";
        radioNo.current.checked = true;
        radioSi.current.checked = false;

        setTimeout(() => txtIdproducto.current.focus(), 200);
      } else {
        setHabilitadoBot(true);
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 2) {
      if (accbtnproducto && accbtnproducto.toString().substring(2, 3) === "1") {
        setVisibleBtn("hidden");
        setTituloHeader("Editar Producto Terminado.");
        setOperacion(op);
        seleccionarUnidadMedida(op);
        seleccionarTipoProd();
        seleccionarFabricante();
        seleccionarMarca();
        seleccionarModelo();
        //seleccionarMoneda();
        txtIdproducto.current.removeAttribute("disabled");
        setHabilitarCat(false);
        setHabilitado(false);
        setHabilitadoBot(false);
        txtIdproducto.current.focus();
      } else {
        setHabilitadoBot(true);
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 3) {
      setOperacion(3);
      if (accbtnproducto && accbtnproducto.toString().substring(3, 4) === "1") {
        setHabilitadoBot(false);
        setVisibleBtn("hidden");
        setTituloHeader("Eliminar Producto Terminado.");

        seleccionarUnidadMedida(op);
        seleccionarTipoProd();
        seleccionarFabricante();
        seleccionarMarca();
        seleccionarModelo();
        //seleccionarMoneda();
        setHabilitado(false);
        txtIdproducto.current.removeAttribute("disabled");
        setHabilitarCat(false);
        txtIdproducto.current.focus();
      } else {
        setHabilitadoBot(true);
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 4) {
      if (accbtnproducto && accbtnproducto.toString().substring(0, 1) === "1") {
        setHabilitadoBot(false);
        setVisibleBtn("hidden");
        setTituloHeader("Consultar Producto Terminado.");
        setOperacion(op);
        seleccionarUnidadMedida(op);
        seleccionarTipoProd();
        seleccionarFabricante();
        seleccionarMarca();
        seleccionarModelo();
        //seleccionarMoneda();
        setHabilitado(false);
        txtIdproducto.current.removeAttribute("disabled");
        setHabilitarCat(false);
        txtIdproducto.current.focus();
      } else {
        setHabilitadoBot(true);
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 5) {
      if (operacion !== 4) {
        onChangeValidar();
      }
    } else if (op === 6) {
      blanquear();
      blanquearAlter();
    } else if (op === 7) {
      //setCatalogoProducto(true);
    }
  };

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };
  const cerrar = () => {
    props.cerrar();
  };
  const chartLabels = ["Servicio", "Bienes"];
  const chartValues = Object.values(grafica[0] || {});
  const generateColors = (count) => {
    const colors = ["#E74C3C", "#3498DB"];
    return Array.from({ length: count }, (_, i) => colors[i % colors.length]);
  };
  const backgroundColors = generateColors(chartLabels.length);

  const chartData = {
    labels: chartLabels,
    datasets: [
      {
        label: "Cantidad",
        data: chartValues,
        backgroundColor: backgroundColors,
        borderColor: "#ffffff",
        borderWidth: 2,
      },
    ],
  };
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: "rgba(0,0,0,0.8)",
        padding: 10,
        cornerRadius: 4,
      },
    },
  };
  useEffect(() => {
    seleccionarRegistrosGrafica();
  }, []);
  return (
    <div className="col-12 m-0 p-5 d-flex">
      <div className="col-8 m-0 p-2 d-flex flex-wrap rounded border-table">
        <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top">
          <h3 className="m-0 fw-bold">{tituloHeader}</h3>
          <a type="button" onClick={cerrar} className="text-light fw-bold fs-6">
            Salir<i className="fas fa-times ms-2"></i>
          </a>
        </header>

        <div className="col-12 m-0 mt-2 p-0 input-group input-group-sm">
          <input
            type="hidden"
            ref={txtIdproductoHidden}
            className="form-control text-uppercase"
          />
        </div>

        <div className="col-12 m-0 mb-2 p-0 d-flex gap-2">
          <div className="col-3 m-0 p-0 input-group input-group-sm my-auto">
            <SearchInput
              label="Código:"
              disabled
              autoComplete="off"
              ref={txtIdproducto}
              onChange={onChange}
              onKeyUp={validarProducto}
              onBlur={validarProducto}
              name="codigo"
              onClickButton={() => setCatalogoProducto(true)}
            />
          </div>
          <div className="col m-0 p-0 gap-2 input-group input-group-sm">
            <label
              className="form-check-label my-auto"
              htmlFor="flexCheckServicio"
            >
              Es un Servicio?
            </label>
            <input
              type="checkbox"
              disabled={!habilitado}
              ref={chkServicio}
              value=""
              id="flexCheckServicio"
            />
          </div>
          <div className="col m-0 p-0 gap-2 input-group input-group-sm">
            <label
              className="form-check-label my-auto"
              htmlFor="flexCheckServicio"
            >
              Exento de IVA: &nbsp;
            </label>
            <input
              type="checkbox"
              ref={txtExento}
              disabled={!habilitado}
              value=""
              id="flexCheckExento"
            />
          </div>
        </div>
        <div className="col-12 m-0 mb-2 p-0 input-group input-group-sm">
          <Input
            label="Nombre"
            ref={txtNombre}
            autoComplete="off"
            disabled={!habilitado}
            id="inputNombre"
            onKeyUp={handleInputChange}
            onBlur={handleInputChange}
            inputClassName="text-uppercase"
          />
        </div>
        <div className="col-5 m-0 p-0 pl-0 pr-2  input-group input-group-sm">
          <Input
            label="Referencia"
            autoComplete="off"
            ref={txtReferencia}
            disabled={!habilitado}
            id="inputRefe"
            onKeyUp={handleInputChange}
            onBlur={handleInputChange}
            inputClassName="text-uppercase"
          />
        </div>
        <div className="col-7 m-0 p-0 input-group input-group-sm">
          <Input
            label="Nombre Corto"
            autoComplete="off"
            ref={txtNombreCorto}
            disabled={!habilitado}
            id="inputNombreCorto"
            onKeyUp={handleInputChange}
            onBlur={handleInputChange}
            inputClassName="text-uppercase"
          />
        </div>
        <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex flex-wrap">
          <legend className="float-none w-auto fw-bold">Configuración</legend>
          <div className="col-6 m-0 mb-2 p-0 d-flex align-items-center gap-2">
            <Select
              label="Tipo Producto/Servicio:"
              disabled={!habilitado}
              ref={cmbTipoProd}
            >
              {tipoP &&
                tipoP.map((tipo) => (
                  <option key={tipo.idtipoproducto} value={tipo.idtipoproducto}>
                    {tipo.descripcion}
                  </option>
                ))}
            </Select>
            <PrimaryButton
              icon="fa-plus m-0"
              disabled={!habilitado}
              onClick={abrirModal("tipop")}
            ></PrimaryButton>
          </div>
          <div className="col-6 m-0 mb-2 p-0 pl-4 d-flex align-items-center gap-2">
            <Select
              label="Fabricante:"
              disabled={!habilitado}
              ref={cmbFabricante}
            >
              {fabri &&
                fabri.map((tipo) => (
                  <option key={tipo.idfabricante} value={tipo.idfabricante}>
                    {tipo.descripcion}
                  </option>
                ))}
            </Select>
            <PrimaryButton
              icon="fa-plus m-0"
              disabled={!habilitado}
              onClick={abrirModal("fabricante")}
            ></PrimaryButton>
          </div>
          <div className="col-6 m-0 mb-2 p-0  d-flex align-items-center gap-2">
            <Select label="Marca:" disabled={!habilitado} ref={cmbMarca}>
              <option value="0">--seleccione--</option>
              {marca &&
                marca.map((mark) => (
                  <option key={mark.idmarca} value={mark.idmarca}>
                    {mark.descripcion}
                  </option>
                ))}
            </Select>
            <PrimaryButton
              icon="fa-plus m-0"
              disabled={!habilitado}
              onClick={abrirModal("marca")}
            ></PrimaryButton>
          </div>
          <div className="col-6 m-0 mb-2 p-0 pl-4 d-flex align-items-center gap-2">
            <Select label="Modelo:" disabled={!habilitado} ref={cmbModelo}>
              <option value="0">--seleccione--</option>
              {modelo &&
                modelo.map((mod) => (
                  <option key={mod.idmodelo} value={mod.idmodelo}>
                    {mod.descripcion}
                  </option>
                ))}
            </Select>
            <PrimaryButton
              icon="fa-plus m-0"
              disabled={!habilitado}
              onClick={abrirModal("modelo")}
            ></PrimaryButton>
          </div>
          <div className="col-4 m-0 mb-2 p-0 d-flex align-items-center gap-2">
            <Select
              label="Unid. Medida:"
              disabled={!habilitado}
              ref={cmbUnidMedida}
              onChange={onChange}
              name="idunidadmedida"
              id="idunidadmedida"
            >
              <option value="">--seleccione--</option>
              {unidadM &&
                unidadM.map((unimedi) => (
                  <option
                    key={unimedi.idunidadmedida}
                    value={unimedi.idunidadmedida}
                  >
                    {unimedi.descripcion}
                  </option>
                ))}
            </Select>
            {/*  <PrimaryButton
              icon="fa-plus m-0"
              disabled={!habilitado}
              onClick={abrirModal("medida")}
            ></PrimaryButton> */}
          </div>
          <div className="col-4 m-0 p-0 px-2">
            <Input
              label="Dias Garantia:"
              type="number"
              disabled={!habilitado}
              ref={txtDiasGar}
              id="inputDiasGar"
              onKeyUp={handleInputChange}
              onBlur={handleInputChange}
            />
          </div>
          <div className="col-4 m-0 p-0">
            <Select
              label="Destino:"
              disabled={!habilitado}
              ref={cmbAlmacen}
              name="almacen"
              onChange={onChange}
            >
              <option value="true">ALMACEN</option>
              <option value="false">USO INTERNO</option>
            </Select>
          </div>
          <div className="col-4 m-0 p-0 " style={{ visibility: visibleA }}>
            <Input
              label="Stock Minimo:"
              autoComplete="off"
              disabled={!habilitado}
              ref={txtStockMini}
              id="stockminimo"
              defaultValue="0,00"
              onFocus={seleccionarCampo}
              onKeyUp={handleInputMontoChange}
              onBlur={handleInputMontoChange}
              inputClassName="text-end"
            />
          </div>

          {valvacio === 1 && (
            <div className="col-4 m-0 p-0 pl-4">
              <Select
                label="TIPO VACIO:"
                disabled={!habilitado}
                ref={txtCodigoVacio}
                onChange={onChange}
                name="idclasevacio"
                id="idclasevacio"
              >
                <option value="">--seleccione--</option>
                {classvacios &&
                  classvacios.map((unimedi) => (
                    <option
                      key={unimedi.idclasevacio}
                      value={unimedi.idclasevacio}
                    >
                      {unimedi.descripcion}
                    </option>
                  ))}
              </Select>
              <PrimaryButton
                icon="fa-plus m-0"
                disabled={!habilitado}
                onClick={abrirModal("classvacios")}
              ></PrimaryButton>
            </div>
          )}
        </fieldset>
        <div className="col-12 m-0 mt-2 p-0 d-flex justify-content-end gap-2">
          <span className="fw-bold">Unidad Alterna:</span>
          <div className="col-auto">
            <Radio
              label="Si"
              disabled={!habilitado}
              ref={radioSi}
              name="flexRadioDefault"
              id="flexRadioDefault1"
              onChange={unidadAlterna}
            />
          </div>
          <div className="col-auto">
            <Radio
              label="No"
              disabled={!habilitado}
              ref={radioNo}
              name="flexRadioDefault"
              id="flexRadioDefault1"
              onChange={unidadAlterna}
            />
          </div>
        </div>

        <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex flex-wrap">
          <legend className="float-none w-auto fw-bold m-0">
            Configuración
          </legend>
          <div className="col-4 m-0 mb-2 p-0">
            <Select
              label="Unid. Principal:"
              disabled={!habilitadoAlter}
              ref={cmbUniPrincipal}
              name="unidadP"
              onChange={onChange}
            >
              <option value="">--seleccione--</option>
              {unidadM &&
                unidadM.map((unimedi) => (
                  <option
                    key={unimedi.idunidadmedida}
                    value={unimedi.idunidadmedida}
                  >
                    {" "}
                    {unimedi.descripcion}
                  </option>
                ))}
            </Select>
          </div>
          <div className="col-4 m-0 mb-2 p-0 pl-4">
            <Select
              label="Unid. Alterna:"
              disabled={!habilitadoAlter}
              ref={cmbUniAlterna}
              name="unidadA"
              onChange={onChange}
            >
              {unidadM &&
                unidadM.map((unimedi) => (
                  <option
                    key={unimedi.idunidadmedida}
                    value={unimedi.idunidadmedida}
                  >
                    {unimedi.descripcion}
                  </option>
                ))}
            </Select>
          </div>
          <div className="col-4 m-0 mb-2 p-0 pl-4">
            <Select
              label="Unid. Salida:"
              disabled={!habilitadoAlter}
              ref={cmbUniVenta}
            >
              {unidadV &&
                unidadV.map((univ) => (
                  <option key={univ.idunidadmedida} value={univ.idunidadmedida}>
                    {univ.descripcion}
                  </option>
                ))}
            </Select>
          </div>
          <div className="col-4 m-0 p-0">
            <Input
              label="Factor Conversion:"
              autoComplete="off"
              disabled={!habilitadoAlter}
              ref={txtFactor}
              id="factorConver"
              onFocus={seleccionarCampo}
              onKeyUp={handleInputMontoChange}
              onBlur={handleInputMontoChange}
            />
          </div>
          <div className="col-4 m-0 p-0 pl-4">
            <Select
              label="X"
              disabled={!habilitadoAlter}
              ref={cmbUniFactor}
              name="unifactor"
              onChange={onChange}
            >
              {factor &&
                factor.map((fac) => (
                  <option key={fac.iduni} value={fac.iduni}>
                    {fac.descripcion}
                  </option>
                ))}
            </Select>
          </div>
          <div className="col-4 m-0 p-0 pl-4">
            <Select
              label="Unid. Ingreso:"
              disabled={!habilitadoAlter}
              ref={cmbUniCompra}
            >
              {unidadC &&
                unidadC.map((unic) => (
                  <option key={unic.idunidadmedida} value={unic.idunidadmedida}>
                    {unic.descripcion}
                  </option>
                ))}
            </Select>
          </div>
        </fieldset>

        {visibleBtn === "visible" && (
          <div className="col-12 m-0 mt-2 p-0 d-flex gap-2 justify-content-end">
            <PrimaryButton
              icon="fa-plus"
              ref={btnIncluir}
              onClick={onBotones(1)}
              disabled={accbtnproducto.toString().substring(1, 2) === "0" ? true : !habilitadoBot}
            >
              Incluir
            </PrimaryButton>
            <InfoButton
              icon="fa-eye"
              ref={btnConsultar}
              onClick={onBotones(4)}
              disabled={accbtnproducto.toString().substring(0, 1) === "0" ? true : !habilitadoBot}
            >
              Consultar
            </InfoButton>
            <WarningButton
              icon="fa-edit"
              ref={btnEditar}
              onClick={onBotones(2)}
              disabled={accbtnproducto.toString().substring(2, 3) === "0" ? true : !habilitadoBot}
            >
              Modificar
            </WarningButton>
            <DangerButton
              ref={btnEliminar}
              onClick={onBotones(3)}
              disabled={accbtnproducto.toString().substring(3, 4) === "0" ? true : !habilitadoBot}
            >
              Eliminar
            </DangerButton>
          </div>
        )}
        {visibleBtn !== "visible" && (
          <div className="col-12 m-0 mt-2 p-0 d-flex gap-2 justify-content-end">
            <SuccessButton
              ref={btnAceptar}
              onClick={onBotones(5)}
              disabled={operacion === 4 ? true : habilitadoBot}
            >
              Aceptar
            </SuccessButton>
            <DangerButton
              ref={btnCancelar}
              onClick={onBotones(6)}
              disabled={habilitadoBot}
            >
              Cancelar
            </DangerButton>
          </div>
        )}
      </div>
      <div className="col-4 m-0 p-0 pl-4">
        <div className="col-md-12 mx-auto mx-0">
          <div
            className=" mb-2 col-xl-6 col-lg-6 col-md-6 mx-auto d-flex justify-content-center"
            style={{ height: 150, width: 150 }}
          >
            <img
              src={pathImage.imagen}
              className="rounded-circle shadow"
              style={{
                height: 150,
                width: 150,
                objectFit: "contain",
                backgroundColor: "#FFFFFF",
              }}
              alt=""
            />
            <input
              type="file"
              disabled={!habilitado}
              style={{
                opacity: 0,
                height: 150,
                width: 150,
                position: "absolute",
                top: 0,
                left: 0,
                cursor: "pointer",
              }}
              onChange={handleUpload}
              name="imagen"
              accept="image/jpeg, image/png"
              className="btn rounded-circle"
            />
          </div>

          <div className="col-xl-12 col-lg-12 h-70 col-md-6 mx-auto ">
            <Card
              sx={{
                borderRadius: 4,
                boxShadow: 3,
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <CardContent
                sx={{
                  p: 2,
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  align="center"
                  mb={1}
                  color="text.secondary"
                  style={{
                    textTransform: "uppercase",
                  }}
                >
                  Tipo de Productos
                </Typography>

                {/* Contenedor del gráfico: Aumentamos flex para que ocupe más espacio */}
                <Box
                  sx={{
                    flex: 1,
                    position: "relative",
                    width: "100%",
                    minHeight: "250px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Pie data={chartData} options={chartOptions} />
                </Box>

                <Box
                  sx={{
                    flexGrow: 0,
                    overflowY: "auto",
                    maxHeight: "40%",
                    mt: 1,
                  }}
                >
                  <List dense sx={{ py: 0 }}>
                    {chartLabels.map((label, index) => (
                      <React.Fragment key={label}>
                        <ListItem
                          sx={{ px: 1, py: 0.5 }}
                          secondaryAction={
                            <Typography
                              variant="body2"
                              fontWeight="bold"
                              color="text.primary"
                            >
                              {chartValues[index]}
                            </Typography>
                          }
                        >
                          <Box
                            sx={{
                              width: 12,
                              height: 12,
                              borderRadius: "50%",
                              backgroundColor: backgroundColors[index],
                              mr: 2,
                              flexShrink: 0,
                            }}
                          />
                          <ListItemText
                            style={{
                              textTransform: "uppercase",
                            }}
                            primaryTypographyProps={{
                              variant: "caption",
                              noWrap: true,
                              sx: { fontSize: "11px" },
                            }}
                            primary={label}
                          />
                        </ListItem>
                        {index < chartLabels.length - 1 && (
                          <Divider component="li" />
                        )}
                      </React.Fragment>
                    ))}
                  </List>
                </Box>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>

      <GestionarMarca
        show={mostrarMarca}
        onHideCancela={() => {
          setMostrarMarca(false);
        }}
        onHideRenderizar={seleccionarMarca}
        llamado={2}
        tipo={"producto"}
      />

      <GestionarModelo
        show={mostrarModelo}
        onHideCancela={() => {
          setMostrarModelo(false);
        }}
        onHideRenderizar={seleccionarModelo}
        llamado={2}
        tipo={"producto"}
      />
      <ActualizarTipopro
        values={[]}
        tipopro={[]}
        cuenta={[]}
        puc={[]}
        operacion={1}
        show={mostrarTipoP}
        onHideCancela={() => {
          setMostrarTipoP(false);
        }}
        onHideRenderizar={seleccionarTipoProd}
      />
      <GestionarFabricantes
        show={mostrarFabricante}
        onHideCancela={() => {
          setMostrarFabricante(false);
        }}
        onHideRenderizar={seleccionarFabricante}
        llamado={2}
        tipo={"producto"}
      />
      <CatalogoProductos
        show={catalogoProducto}
        onHideCancelar={() => setCatalogoProducto(false)}
        onHideAceptaCatalogo={onCatalogoProducto}
      />

      <Dimmer active={activate} inverted></Dimmer>

      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default TablaProdTerminadoe;
